exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n@keyframes blink {\n0% {\n    opacity: 0;\n}\n33% {\n    opacity: 1;\n}\n66% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n.btnMarkAsRefunded[data-v-7566fdd0] {\n  animation: 1s ease-out 0s 1 blink;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7566fdd0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEditV2/TabPayments/expandedArea/historyPayment.vue
// module id = 1904
// module chunks = 0